import { createServer } from 'miragejs';

import LocalStorageManager from 'mocks/server/localStorageManager';
import { dataManagementRoutes } from 'mocks/server/routes/dataManagementRoutes';
import { draftsRoutes } from 'mocks/server/routes/draftsRoutes';
import { entitiesRoutes } from 'mocks/server/routes/entitiesRoutes';
import { framesRoutes } from 'mocks/server/routes/framesRoutes';
import { linkedAssetsRoutes } from 'mocks/server/routes/linkedAssetsRoutes';
import { otherRoutes } from 'mocks/server/routes/otherRoutes';
import { clearAllMockData, populateMockData } from 'mocks/server/utils/dataPopulator';
import { AZURE_AD_AUTH_PATHS } from 'mocks/server/utils/defaults';
import {
  IBaseEntity,
  IDraftFrame,
  IDraftLinkedAsset,
  ILiveFrame,
  ILiveLinkedAsset,
} from 'types/detailsEntityType';
import { PERSIST_MOCK_SERVER_DATA } from 'utils/environmentVariables';

/**
 * Link to MirageJS -> https://miragejs.com/
 * MirageJS is used to intercept network traffic and dynamically return mocked results
 */
export const makeServer = ({ environment = 'development' } = {}) =>
  createServer({
    environment,

    routes() {
      this.timing = 600;

      const removedEntities = new LocalStorageManager<IBaseEntity>('removedEntities');
      const draftFrameStore = new LocalStorageManager<IDraftFrame>('draftFrames');
      const draftLinkedAssetStore = new LocalStorageManager<IDraftLinkedAsset>('draftLinkedAssets');
      const frameStore = new LocalStorageManager<ILiveFrame>('frames');
      const linkedAssetStore = new LocalStorageManager<ILiveLinkedAsset>('linkedAssets');

      if (PERSIST_MOCK_SERVER_DATA !== 'true') {
        clearAllMockData(
          removedEntities,
          draftFrameStore,
          draftLinkedAssetStore,
          frameStore,
          linkedAssetStore
        );
      }

      populateMockData(
        removedEntities,
        draftFrameStore,
        draftLinkedAssetStore,
        frameStore,
        linkedAssetStore
      );

      otherRoutes(this);
      entitiesRoutes(this, frameStore, linkedAssetStore);
      framesRoutes(this, frameStore);
      linkedAssetsRoutes(this, linkedAssetStore);
      draftsRoutes(this, draftFrameStore, draftLinkedAssetStore, removedEntities);
      dataManagementRoutes(this);

      // Allows the network traffic for Azure AD authentication to pass through
      // More info here -> https://miragejs.com/api/classes/server/#passthrough
      this.passthrough(AZURE_AD_AUTH_PATHS);
    },
  });
